import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundImage:
      'linear-gradient(180deg,rgba(12,113,195,0.64) 0%,rgba(0,0,0,0.38) 100%),url(https://solutions.crediblemind.com/wp-content/uploads/2020/01/AdobeStock_210475109-1.jpeg)!important',
    paddingTop: '10%',
    paddingBottom: '5%',
    backgroundSize: 'cover',
  },
  headerBlock: {
    marginBottom: 30,
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 30,
    },
  },
  h1: {
    fontFamily: 'PoppinsBold',
    fontSize: 64,
    fontWeight: '700',
    color: 'rgba(255, 255, 255, 0.6)',
    letterSpacing: 2,
    lineHeight: '1.1em',
    paddingBottom: 10,
    textAlign: 'center',
    width: '80%',
    marginRight: 'auto',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: 34,
      paddingBottom: 20,
    },
  },
  h2: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 21,
    fontWeight: '600',
    color: '#FFFFFF',
    letterSpacing: 2,
    lineHeight: '1.3em',
    textAlign: 'center',
    paddingBottom: 10,
    textShadow: '0em 0em 0.3em rgba(0,0,0,0.4)',
    width: '80%',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  body: {
    fontFamily: 'OpenSansRegular',
    fontSize: 16,
    lineHeight: '1.8em',
    textAlign: 'center',
    color: '#FFFFFF',
    width: '80%',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: '0.4em',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1em',
    },
  },
  buttonBlock: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 30,
    },
  },
  buttonRoot: {
    color: '#FFFFFF',
    borderRadius: 4,
    letterSpacing: 2,
    fontSize: 15,
    fontFamily: 'MontserratSemiBold',
    fontWeight: '600',
    textTransform: 'uppercase',
    backgroundColor: '#0C71C3',
    padding: '12px 1em',
    transition: 'all 300ms ease 0ms',
    position: 'relative',
    boxShadow: '0px 2px 18px 0px rgba(0,0,0,0.3)',
    '& > svg': {
      position: 'absolute',
      opacity: 0,
      marginLeft: '-1em',
      transition: 'all 300ms ease 0ms',
      right: 4,
    },
    '&:hover': {
      paddingRight: '2em',
      paddingLeft: '0.7em',
      '& > svg': {
        opacity: 1,
        marginLeft: 0,
      },
    },
  },
}));

function Hero({ onPageExit }) {
  const classes = useStyles();

  const buttons = [
    {
      title: 'For Communities',
      link: 'https://solutions.crediblemind.com/crediblemind-for-communities',
    },
    {
      title: 'For Employers',
      link: 'https://solutions.crediblemind.com/crediblemind-for-employers',
    },
    {
      title: 'For Health Systems',
      link:
        'https://solutions.crediblemind.com/crediblemind-for-health-systems',
    },
  ];

  return (
    <section id="hero">
      <div className={classes.wrapper}>
        <div className={classes.headerBlock}>
          <LazyAnimation type="translate-top-20 fade-in">
            <Typography className={classes.h1}>
              Mental Wellbeing Resources You Can Trust
            </Typography>
            <Typography className={classes.h2}>
              Introducing the early intervention platform to help people
              flourish
            </Typography>
          </LazyAnimation>
          <LazyAnimation type="translate-top-20 fade-in">
            <Typography className={classes.body}>
              Over 75% of people approach mental health issues on their own with
              no professional assistance.
            </Typography>
            <Typography className={classes.body}>
              That&apos;s why we offer <b>evidence-based</b> self-help for 200+
              mental health and wellbeing topics.
            </Typography>
            <Typography className={classes.body}>
              We call this Population-based Mental Health. Let us show you how
              to empower your organization today.
            </Typography>
          </LazyAnimation>
        </div>
        <LazyAnimation type="fade-in">
          <div className={classes.buttonBlock}>
            <Grid container justify="center">
              {buttons.map(button => (
                <Grid
                  item
                  xs={12}
                  md={4}
                  className={classes.buttonWrapper}
                  key={button.title}
                >
                  <ButtonBase
                    component="a"
                    classes={{ root: classes.buttonRoot }}
                    disableRipple
                    href={button.link}
                    target="_blank"
                    onClick={() => onPageExit(button.link, 'hero')}
                  >
                    {button.title}
                    <ChevronRightIcon />
                  </ButtonBase>
                </Grid>
              ))}
            </Grid>
          </div>
        </LazyAnimation>
      </div>
    </section>
  );
}

Hero.propTypes = {
  onPageExit: PropTypes.func,
};

export default Hero;
